<template>
    <div>
        <div class="columns">
            <div class="column is-2">
                <label class="label">Search provider</label>
                <div class="field has-addons">
                    <p class="control">
                        <input type="text" class="input oc-input is-small" placeholder="Provider"
                            v-model="searchProvider">
                    </p>
                    <div class="control">
                        <button @click="searchProvider=''" class="button is-danger is-small">Clear</button>
                    </div>
                </div>
                <item-list :activeItem="provider" :selectItem="selectProvider" :items="providersByName" />
            </div>
            <div class="column is-3">
                <label class="label">
                    Search category
                </label>
                <div class="field has-addons">
                    <p class="control">
                        <input type="text" class="input oc-input is-small" placeholder="Category"
                            v-model="searchCategory">
                    </p>
                    <div class="control">
                        <button class="button is-small is-danger" @click="searchCategory=''">Clear</button>
                    </div>
                </div>
                <ul class="aggregator-list">
                    <li v-for="item in categoriesByName" :key="item.name">
                        <div class="level">
                            <div class="level-left">
                                <p class="control">
                                    <button class="button is-small" >{{ item.name }}</button>
                                </p>
                            </div>
                            <div  class="level-right">
                                <div class="field has-addons">
                                    <div class="control">
                                        <input class="input is-small" v-model="item.newName" type="text" placeholder="New categoryName" >
                                    </div>
                                    <div class="control">
                                        <button class="button is-success is-small" @click="save(item.name, item.newName)" :disabled="loading">Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import betconstructService from '../../../../services/betconstruct.service';
import gameService from '../../../../services/game.service';

import itemList from '../../../common/item-list.vue';
export default {
    name: "client-games-aggregator-settings",
    components: {itemList},
    data() {
        return {
            searchProvider: '',
            searchCategory: '',
            provider: null,
            newCategoryName: null,
            games: [],
            providers: [],
            categories: [],
            categoriesByProviders: [],
            loading: false
        }
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        },
        aggregator() {
            return this.$route.params.aggregator;
        },
        providersByName() {
            return this.providers.filter(item => item === this.provider || item.toLowerCase().indexOf(this.searchProvider.toLowerCase()) !== -1);
        },
        categoriesByName() {
            return this.categories.filter(item => item.name.toLowerCase().indexOf(this.searchCategory.toLowerCase()) !== -1);
        }
    },
    async mounted() {
        this.loadGames();
    },
    methods: {
        selectProvider(name) {
            this.searchCategory = '';
            if(this.provider === name){
                this.provider = null;
                this.getProviders();
            } else {
                this.provider = name;
                this.providers.splice(this.providers.indexOf(name),1);
                this.providers.unshift(name);
                this.categories = this.categoriesByProviders[name].map((category) => {return {name: category, newName: ''}});
            }
        },
        async loadGames(){
            this.games = await gameService.getClientGames(this.clientId, this.aggregator);
            this.getProviders();
        },
        getProviders() {
            const data = betconstructService.getProviders(this.games);
            this.categoriesByProviders = data.providers;
            this.providers = Object.keys(data.providers);
            if(!this.provider){
                this.categories = data.categories.map((category) => {return {name: category, newName: ''}});
            } else {
                this.categories = this.categoriesByProviders[this.provider].map((category) => {return {name: category, newName: ''}});
            }
        },
        async save(category, newCategory) {
            this.loading = true;
            await betconstructService.renameCategory(this.clientId, this.provider, category, newCategory, this.loadGames);
            this.loading = false;
        }
    },
    watch: {
        async clientId() {
            this.loadGames();
        }
    }
}
</script>
<style scoped lang="scss">
p.control input {
    max-width: 600px;
}
.column .field .control:first-child{
  flex-grow: 1;
}
.aggregator-list {
    max-height: 200px;
    max-width: 600px;
    overflow: hidden;
    overflow-y: auto;

    li {
        margin-bottom: 5px;
    }
}
</style>


// WEBPACK FOOTER //
// front/src/components/clients/client/games/aggregator-settings.vue